import type { SkillType } from '@/utils/testPromptAnswerMatrix'

/** Режим завершения теста: как прогон понимает, что закончился. */
export type TestCompletionMode = 'classic' | 'timed' | 'series'

/**
 * Цель проверки карточки.
 *
 * Псевдоним матричного `SkillType`, а не своя копия союза: набор навыков задаёт
 * матрица `prompt × answer`, и второй список разъехался бы с ней молча.
 */
export type TestSkillGoal = SkillType

/**
 * Задан ли режим завершения целиком.
 *
 * У «На время» и «Серии» число обязательно: сервер отбивает
 * `required_if:completion_method.mode,...` четыреста двадцать вторым, а подстановка
 * нуля вместо пустого поля дала бы тест на ноль минут вместо ошибки.
 */
export function completionModeIsComplete(
  mode: TestCompletionMode,
  durationMin: number | '',
  seriesTarget: number | '',
): boolean {
  if (mode === 'timed') return durationMin !== ''
  if (mode === 'series') return seriesTarget !== ''

  return true
}

